// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"254":"63a18a32","471":"a9ef2090","589":"e1d84aa4","622":"a2ac03ef","778":"db613133","858":"381f82c1","973":"fb6b44f3"}[chunkId] + ".chunk.js";
};